import React from "react";

import { TextElementMen } from "@/components/ui-kit/TextElementMen/TextElementMen";
import {
  TextElementNova,
  TextElementNovaPropsBase,
} from "@/components/ui-kit/TextElementNova/TextElementNova";
import { cn } from "@/utils/general";
import { ThemeTypes } from "@/utils/theming";

export interface BadgeProps {
  theme?: ThemeTypes;
  classes?: string;
  lineOne?: string;
  lineOneProps?: TextElementNovaPropsBase;
  lineTwo?: string;
  lineTwoProps?: TextElementNovaPropsBase;
  mode?: "light" | "dark";
}

const Badge: React.FC<BadgeProps> = ({
  classes = `mx-auto flex flex-col text-center gap-1`,
  theme = `women`,
  lineOne = `#1 Dermatologist-Recommended`,
  lineOneProps,
  lineTwo = `Hair Growth Supplement Brand*`,
  lineTwoProps,
  mode = "light",
}) => {
  const isMen = theme === "men";

  return (
    <div className={classes}>
      {isMen ? (
        <>
          <TextElementMen
            text={lineOne}
            element="p"
            className={cn(
              `Body-20-Dia-Strong text-center`,
              mode === "dark" && `text-nova-base-white`
            )}
          />
          <TextElementMen
            text={lineTwo}
            element="p"
            className={cn(
              `Caption-10-Dia-Uppercase text-nova-transparency-black-60 text-center`,
              mode === "dark" && `text-nova-transparency-white-60`
            )}
          />
        </>
      ) : (
        <>
          <TextElementNova
            text={lineOne}
            element="p"
            {...lineOneProps}
            className={cn(
              !lineOneProps?.classes?.default && `Body-20-Dia-Strong`,
              `text-center`,
              mode === "dark" && `text-nova-base-white`,
              lineOneProps?.className
            )}
          />
          <TextElementNova
            text={lineTwo}
            element="p"
            {...lineTwoProps}
            className={cn(
              !lineTwoProps?.classes?.default && `Body-20-Dia-Normal`,
              `text-nova-transparency-black-60 text-center`,
              mode === "dark" && `text-nova-transparency-white-60`,
              lineTwoProps?.className
            )}
          />
        </>
      )}
    </div>
  );
};

export default Badge;
